var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-selector"},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight},on:{"click":_vm.handleCanvasClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }